module.exports = __webpack_public_path__ + "img/button5.686ac4d3.png";